module.exports = __webpack_public_path__ + "img/xlkpzj.db5196b8.jpg";